/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_TitleInputs */

const en_community_invite_title = /** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have been invited to join`)
};

const id_community_invite_title = /** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda telah diundang untuk bergabung dengan`)
};

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const es_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const fr_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const de_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const ja_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const zh_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const ar_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const it_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const ru_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const pt_community_invite_title = en_community_invite_title;

/** @type {(inputs: Community_Invite_TitleInputs) => LocalizedString} */
const ko_community_invite_title = en_community_invite_title;

/**
* | output |
* | --- |
* | "You have been invited to join" |
*
* @param {Community_Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_title = /** @type {((inputs?: Community_Invite_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_title(inputs)
	if (locale === "es") return es_community_invite_title(inputs)
	if (locale === "fr") return fr_community_invite_title(inputs)
	if (locale === "de") return de_community_invite_title(inputs)
	if (locale === "ja") return ja_community_invite_title(inputs)
	if (locale === "zh") return zh_community_invite_title(inputs)
	if (locale === "ar") return ar_community_invite_title(inputs)
	if (locale === "id") return id_community_invite_title(inputs)
	if (locale === "it") return it_community_invite_title(inputs)
	if (locale === "ru") return ru_community_invite_title(inputs)
	if (locale === "pt") return pt_community_invite_title(inputs)
	return ko_community_invite_title(inputs)
});